<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        产品信息
      </div>

      <div>
        <div style="margin:10px 10px 10px 0;display:inline-block">
          退货地址：{{ this.allAddress }},{{ this.userName }},{{ this.telNum }}
        </div>
        <!-- <el-button type="primary" @click="setMaterialNum()">
          设置料号
        </el-button> -->

        <el-autocomplete
          v-model="storageName"
          :fetch-suggestions="queryStorageName"
          placeholder="请输入"
          style="margin: 0 10px;"
        />
        <el-button type="primary" @click="selectStorageName(storageName)">
          批量设置库位
        </el-button>
      </div>

      <!-- <div class="rj-page-card__content"> -->
      <el-table
        :data="rejectedList.length === 0?[]:rejectedList[0].addressList[0].contractProductList"
        border
        show-summary
        :summary-method="getSummaries"
        style="width: 100%"
      >
        <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
        <el-table-column
          prop="erpLineNum"
          label="ERP行号"
          align="left"
        />
        <el-table-column
          prop="rproductCode"
          label="销售产品代码"
          align="left"
        />
        <el-table-column label="料号" align="left">
          <template v-slot="{row}">
            {{ row.rmaterialNum }}
            <!-- <el-button type="text" @click="setMaterialNum(row,$index)">
              {{ row.rmaterialNum?row.rmaterialNum:'选择料号' }}
            </el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="rproductName"
          label="产品型号"
          align="left"
        />
        <el-table-column
          prop="rproductUnit"
          label="单位"
          align="left"
          width="180"
        />
        <el-table-column
          prop="rproductNum"
          label="数量"
          align="left"
          width="180"
        >
          <template slot-scope="{ row }">
            -{{ row.rproductNum }}
          </template>
        </el-table-column>
        <el-table-column
          prop="rproductPrice"
          label="单价"
          align="right"
          header-align="left"
          width="180"
        />
        <el-table-column
          prop="rproductPriceAdd"
          label="订单金额"
          align="right"
          header-align="left"
          width="180"
        />
        <el-table-column
          prop="rproductActualPriceAdd"
          label="实际结算金额"
          align="right"
          header-align="left"
          width="180"
        />
        <el-table-column
          prop="rbeforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
          width="180"
        />
        <el-table-column
          prop="rfictitiousReturn"
          label="真实/虚拟退货"
          align="left"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.rfictitiousReturn">真实退</span>
            <span v-if="!scope.row.rfictitiousReturn">虚拟退</span>
          </template>
        </el-table-column>
        <el-table-column
          label="库位"
          align="left"
          width="180"
        >
          <template slot-scope="{ row }">
            <el-autocomplete
              v-model="row.rstorageName"
              :fetch-suggestions="queryStorageName"
              placeholder="请输入内容"
            />
          </template>
        </el-table-column>

        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
          width="120"
        />
      </el-table>
      <!-- </div> -->
    </div>
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>

<script>
import MaterialNum from '../../contractCommonInput/MaterialNum';
import { MathAdd, MathMulti } from '@/libs/util';
import { getStorageByKeyWords } from '@/API';

export default {
  name: 'RejectedList',
  data () {
    return {
      rejectedList: this.productData,
      dialogVisibleBool: false,
      setSerialData: {},
      // 库位名
      storageName: ''
    };
  },
  components: {
    MaterialNum
  },
  computed: {
    allAddress () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rfullAddress;
      }
      return res;
    },
    userName () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rreceiveUserName;
      }
      return res;
    },
    telNum () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rreceiveTel;
      }
      return res;
    }
  },
  props: {
    productData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },
  watch: {
    productData (val) {
      this.rejectedList = val;
    }
  },
  methods: {
    // 查询库位名
    queryStorageName (val, cb) {
      let noneList = [];
      if (!val) return cb(noneList);

      getStorageByKeyWords({ keyWords: val }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let list = JSON.parse(json.data);
          let arr = list.map(item => ({
            value: item.storageName
          }));
          cb(arr);
        }
      }).catch(() => {});
    },

    // 批量设置库位
    selectStorageName (val) {
      if (!val) return;
      let arr = JSON.parse(JSON.stringify(this.rejectedList));
      let list = arr[0] ? arr[0].addressList[0].contractProductList : [];
      list.forEach(mk => { mk.rstorageName = val; });
      this.rejectedList = arr;
    },

    // 设置序列号
    setSerialNum () {
      this.dialogVisibleBool = true;
      this.setSerialData = {
        'contractId': 1,
        'getGoodsList': 2
      };
      // this.$notify.error({
      //   message: '设置冲销序列号'
      // });
    },
    setSerialClose (val) {
      this.dialogVisibleBool = val;
    },
    getTableData (val) {
      this.rejectedList = val;
    },
    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.AssignAmount(param.data);
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.trueAmount(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.beforPrice(param.data);
        }
      });
      return sums;
    },
    // AssignAmount () {
    //   let cont = 0;
    //   this.rejectedList[0].addressList[0].contractProductList.forEach((item) => {
    //     cont += item.rproductPriceAdd;
    //   });
    //   return cont;
    // },
    AssignAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      cont = Number(cont).toFixed(2);
      return `-${cont}`;
    },
    trueAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      cont = Number(cont).toFixed(2);
      return `-${cont}`;
    },
    beforPrice (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, MathMulti(item.rbeforeSplitPrice, Number(item.rproductNum)));
      });
      cont = Number(cont).toFixed(2);
      return `-${cont}`;
    },
    // trueAmount () {
    //   let cont = 0;
    //   this.rejectedList[0].addressList[0].contractProductList.forEach((item) => {
    //     cont += item.rproductActualPriceAdd;
    //   });
    //   return cont;
    // },
    // beforPrice () {
    //   let cont = 0;
    //   this.rejectedList[0].addressList[0].contractProductList.forEach((item) => {
    //     cont += item.rbeforeSplitPrice;
    //   });
    //   return cont;
    // },
    setMaterialNum (row, index) {
      // if (!this.contractType) {
      //   this.$notify.error({
      //     message: '请先选择订单分类'
      //   });
      //   return;
      // }
      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.rejectedList[0].addressList[0].contractProductList.forEach((item, index) => {
          if (item.rproductCode) {
            productAndMaterialGroup.push({
              productSalesCode: item.rproductCode,
              productName: item.rproductName,
              exclusiveMaterial: item.rmaterialNum || '',
              productNum: item.rproductNum,
              isHavePowerCord: item.isHavePowerCord || false,
              isTestOrder: item.isBorrow || false
            });
            MaterialNumValues[item.rproductCode] = {
              materialNumberId: item.rmaterialNum,
              materialUnit: item.rmaterialUnit
            };
          }
        });
      } else {
        if (row.rproductCode) {
          productAndMaterialGroup.push({
            productSalesCode: row.rproductCode,
            productName: row.rproductName,
            exclusiveMaterial: row.rmaterialNum,
            productNum: row.rproductNum,
            isHavePowerCord: row.isHavePowerCord || false,
            isTestOrder: row.isBorrow || false
          });
          MaterialNumValues[row.rproductCode] = {
            materialNumberId: row.rmaterialNum,
            materialUnit: row.rmaterialUnit
          };
        } else {
          return;
        }
      }
      let param = {
        contractType: '',
        contractNumber: this.info.rnewContractNum,
        contractName: this.info.rprojectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };
      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateria ({ list, RowIndex }) {
      if (RowIndex === 'all') {
        let cx = 0;
        this.rejectedList[0].addressList[0].contractProductList.forEach((pro, index) => {
          let mate = list[index - cx];
          if (pro.rproductCode === mate.productSalesCode) {
            pro.rmaterialNum = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.rmaterialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
          if (pro.exclusiveMaterialNumber) {
            cx++;
          }
        });
      } else {
        this.rejectedList[0].addressList[0].contractProductList[RowIndex].rmaterialNum = list[0].selected;
        this.rejectedList[0].addressList[0].contractProductList[RowIndex].rmaterialUnit = list[0].materialUnit;
        this.rejectedList[0].addressList[0].contractProductList[RowIndex].softFlag = list[0].softFlag;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
